module.exports = __webpack_public_path__ + "static/language-2-mobile-bdb76489c2a45fa36ddec763fdd803a6.jpg";